import React, { ReactNode } from "react";

import { IgCustomTheme, IgPaper, IgTypography } from "@intelligems/ig-theme";
import { Grid, useTheme } from "@mui/material";

interface ScratchCardProps {
  card: {
    id?: string;
    title: ReactNode;
    description?: ReactNode;
    icon: ReactNode;
    iconColor?: string;
    backgroundColor?: string;
  };
  onClick: () => void;
  isSelected?: boolean;
  isSelectable?: boolean;
}

export const ScratchCard = ({
  card,
  onClick,
  isSelected = false,
  isSelectable = false,
}: ScratchCardProps) => {
  const theme = useTheme<IgCustomTheme>();

  return (
    <Grid container item direction={"column"} key={card.id} onClick={onClick}>
      <IgPaper
        isClickable={true}
        sx={{
          borderRadius: "6px",
          boxShadow: theme.igShadows.low,
          padding: 5,
          backgroundColor: isSelected
            ? theme.igBackgroundColors.accent
            : undefined,
          border: isSelected
            ? `1px solid ${theme.igBorders.accent.active}`
            : undefined,
          ...(isSelected && {
            "&:hover": {
              backgroundColor: theme.igBackgroundColors.accent,
              borderColor: theme.igBorders.accent.active,
            },
          }),
        }}
      >
        <Grid item container direction={"column"} rowSpacing={3} mt={0}>
          <Grid
            item
            sx={{
              backgroundColor:
                card.backgroundColor ||
                theme.igBackgroundColors.interactive.neutral.default,
              padding: 2,
              paddingTop: "8px !important",
              width: "40px",
              height: "40px",
              borderRadius: 1,
            }}
          >
            {card.icon}
          </Grid>
          <Grid item>
            <IgTypography>{card.title}</IgTypography>
          </Grid>
        </Grid>
      </IgPaper>
    </Grid>
  );
};
